<div
	class="relative w-full px-6 py-10 mx-auto space-y-6 bg-white rounded-lg shadow-lg sm:p-14 sm:!w-96"
>
	<!-- title & close -->
	<div class="flex items-center justify-between gap-4 mb-4">
		<h2 class="text-2xl font-bold">Share Review</h2>
		<uc-close-modal />
	</div>

	<!-- share on twitter -->
	<a
		(click)="onShare('twitter')"
		aria-label="Share on Twitter"
		class="flex items-center w-full gap-3 px-4 py-3 border rounded-md shadow-sm cursor-pointer hover:bg-gray-50"
	>
		<uc-twitter-v2-svg />
		Twitter
	</a>

	<!-- share on facebook -->
	<a
		(click)="onShare('facebook')"
		aria-label="Share on Facebook"
		class="flex items-center w-full gap-3 px-4 py-3 border rounded-md shadow-sm cursor-pointer hover:bg-gray-50"
	>
		<uc-facebook-v2-svg />
		Facebook
	</a>
</div>
